import React, { useRef, useEffect, useState } from "react";
import Header from "../../Components/update/Header";
import Contact from "../update/Contact";
import * as onnx from "onnxruntime-web";

const wsUrl = "ws://localhost:8000/ws";
const apiUrl = "http://localhost:8000";
let standardWidth = 400;
let standardHeight = 400;

export default function Detection() {
  const videoRef = useRef();
  const canvasRef = useRef();
  const detectedRef = useRef();
  const [ready, setReady] = useState(false);
  const [session, setSession] = useState(null);
  // const [imageData, setImageData] = (useState < string) | (null > null);

  const streamRef = useRef();
  const ws = useRef();

  useEffect(() => {
    if (ws.current) return; // Prevent duplicate

    ws.current = new WebSocket(wsUrl);

    // const interval = setInterval(sendFrame, 200); // every 200ms i.e 5 fps
    ws.current.onopen = () => {
      console.log("connection established");
    };
    ws.current.onmessage = (e) => {
      const data = JSON.parse(e.data);
      plotImage(data);
    };
    return () => {
      console.log("closing websocket");
      // clearInterval(interval);
      ws.current.close();
      ws.current = null;
    };
  }, []);
  useEffect(() => {
    if (!ready) return;
    const sendFrames = () => {
      const detection = detectedRef.current;
      const video = videoRef.current;
      const context = detection.getContext("2d");
      if (context) {
        context.drawImage(video, 0, 0, detection.width, detection.height);
        detection.toBlob((blob) => {
          if (!blob) {
            console.log("failed to create blob");
            return;
          }
          ws.current.send(blob);
        });
      }
    };
    // sendFrames();
    const interval = setInterval(sendFrames, 200);
    console.log(interval);
    return () => {
      console.log("cleanup run");
      clearInterval(interval);
    };
  }, [ready]);

  const addVideoToCanvas = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { width: { ideal: 640 }, height: { ideal: 640 } },
      });
      console.log(stream);
      streamRef.current = stream;
      videoRef.current.srcObject = streamRef.current;
      await videoRef.current.play();
      // setTimeout(() => {
      setReady(true);
    } catch (error) {
      console.log("error occured in get media from device", error);
    }
  };
  const stopCamera = () => {
    try {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
        streamRef.current = null;
      }
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      setReady(false);
      clear();
    } catch (error) {
      console.log("error occured in stopping camera");
    }
  };

  const capturePhoto = () => {
    try {
      if (!streamRef.current || !videoRef.current) {
        throw Error("canvas or video element is undefined");
      }
      const video = videoRef.current;
      console.log(video);
      const canvas = detectedRef.current;
      const context = canvas.getContext("2d");
      if (context) {
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(async (blob) => {
          // console.log(blob);
          if (!blob) {
            return;
          }
          ws.current.send(blob);
        });
        // setImageData(dataUrl);
      }
    } catch (error) {
      console.log("cannot capture photo", error);
    }
  };

  const plotImage = (result) => {
    try {
      const detectionContext = detectedRef.current;
      const ctx = detectionContext.getContext("2d");
      if (!ctx) {
        console.log("detection context not defined");
        return;
      }
      ctx.clearRect(0, 0, detectionContext.width, detectionContext.height);
      // const img = new Image();
      // // img.src = URL.createObjectURL(imageFile);
      // img.src = imageData;
      // const [imageData, setImageData] = useState(null);

      // img.onload = function () {
      // console.log("image loaded");
      // ctx.drawImage(img, 0, 0, detectionContext.width, detectionContext.height);
      // console.log("drawing text");
      ctx.lineWidth = 3;
      ctx.font = "20px Arial";
      ctx.strokeStyle = "#255925ff";
      ctx.fillStyle = "#BBC863";
      if (result.boxes.length > 0) {
        result.boxes.forEach((box, idx) => {
          const [x1, y1, x2, y2] = box;
          const label = result.detected_class[idx];
          ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);
          ctx.fillText(label, x1 + 15, y1 + 35);
        });
        return;
      }
      ctx.fillText("No Object Detected !", 200, 50);
      // };

      // ctx.drawImage(img, 0, 0);
      // img.onerror = () => console.log("Failed to load image");
    } catch (error) {
      console.log("cannot plot image", error);
    }
  };
  const clear = () => {
    const ctx = detectedRef.current.getContext("2d");
    if (ctx) {
      ctx.clearRect(
        0,
        0,
        detectedRef.current.width,
        detectedRef.current.height
      );
    }
  };
  const loadModel = async () => {
    try {
      const session = await onnx.InferenceSession.create("/models/best.onnx");
      setSession(session);
      console.log("model loaded", session);
    } catch (error) {
      console.log("error occured in loading files", error);
    }
  };
  return (
    <div>
      <Header />
      <div>
        <div className="flex flex-col items-center justify-center min-h-screen gap-4 bg-gray-700">
          <div className="flex gap-4">
            <button onClick={capturePhoto}>capturePhoto</button>
            <button onClick={loadModel}>loadModel</button>
          </div>
          <div className="flex items-center">
            <div>
              <h3 className="text-light-700 mb-2">Input stream: </h3>

              <video
                ref={videoRef}
                width={standardWidth}
                height={standardHeight}
                className="border-2 border-gray-300 rounded-xl bg-black"
                autoPlay
                playsInline
              />
            </div>

            <div className="ml-3">
              <h3 className="text-light-700 mb-2">Detected Image: </h3>

              <canvas
                ref={detectedRef}
                width={standardWidth}
                height={standardHeight}
                className="border border-gray-300 rounded-xl"
              />
            </div>
          </div>

          <div className="flex gap-4">
            <button onClick={addVideoToCanvas}>addVideo</button>
            <button onClick={stopCamera}>stop camera</button>
          </div>
        </div>
      </div>
      <Contact />
    </div>
  );
}
